export const setDirection = (text: string) => {
  const arabicRegex =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+/;
  const englishRegex = /[a-zA-Z]+/;
  const numberRegex = /^\d+/;
  const words = text.trim().split(/\s+/);
  // decide by first Alphabetical word
  let firstAlphabeticalIndex = 0;
  while (
    numberRegex.test(words[firstAlphabeticalIndex]) &&
    !arabicRegex.test(words[firstAlphabeticalIndex]) &&
    !englishRegex.test(words[firstAlphabeticalIndex])
  ) {
    firstAlphabeticalIndex++;
  }
  if (arabicRegex.test(words[firstAlphabeticalIndex])) return "rtl";
  if (englishRegex.test(words[firstAlphabeticalIndex])) return "ltr";

  return "rtl";
};
